<template>
    <div class="page-box mt-60">
        <!-- 写一个swiper -->
        <div class="banner">
            <swiper :options="swiperOption">
                <swiper-slide v-for="(item, index) in tabdata" :key="index">
                    <a href="javascript:;" class="banner-link">
                        <img :src="item.tb_image_url" alt="">
                    </a>
                </swiper-slide>
            </swiper>
        </div>

        <div class="content-box">
            <div class="container-box">
                <!-- 面包屑导航 -->
                <div class="fs-14">
                    <span class="c-9 cup">{{ $t('首页') }}</span><span class="ml-6 mr-6">/</span>
                    <span class="cup">{{ $t('关于我们') }}</span>
                </div>

                <!-- 关于我们 -->
                <div class="list-card">
                    <div class="t1">
                        {{ $t('关于我们') }}
                    </div>
                    <div class="desc" v-html="aboutData">
						
                    </div>
                </div>

                <!-- 加入Oceanclub社区 -->
                <div class="list-card">
                    <div class="t1">{{ $t('加入OceanClub社区，您可以进行') }}</div>
                    <div class="card-box mt-26 df">
                        <div class="card-list f1">
                            <img src="@/assets/images/img44.png" class="p-img" alt="">
                            <div class="td1">{{ $t('同行交流') }}</div>
                            <div class="d1">
                                {{ $t('参加线下及线上研讨会、走进知名企业等活动，与优秀同行面对面交流，分享实践，解决问题，获取支持') }}
                            </div>
                        </div>
                        <div class="card-list f1">
                            <img src="@/assets/images/img44.png" class="p-img" alt="">
                            <div class="td1">{{ $t('培训赋能') }}</div>
                            <div class="d1">
                                {{ $t('参加社区理论课程和动手实验课程，学习存储技术和行业热点解决方案，提升理论水平和解决实际问题的能力') }}
                            </div>
                        </div>
                        <div class="card-list f1">
                            <img src="@/assets/images/img44.png" class="p-img" alt="">
                            <div class="td1">{{ $t('洞察产业') }}</div>
                            <div class="d1">
                                {{ $t('通过社区用户共创的技术专刊，掌握数据存储产业的最新趋势、技术前沿、专家观点和最佳实践') }}
                            </div>
                        </div>
                        <div class="card-list f1">
                            <img src="@/assets/images/img44.png" class="p-img" alt="">
                            <div class="td1">{{ $t('联合创新') }}</div>
                            <div class="d1">
                                {{ $t('参与社区的联合创新项目和需求定义，发表联合创新成果，引领全球存储产业方向') }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="list-card">

                    <div class="t1">{{ $t('会员积分制度与权益') }}</div>

                    <img :src="imgurl" class="d-img" alt="">
                    <!-- <img src="@/assets/images/integral_en.png" class="d-img" alt=""> -->

                </div>

            </div>
        </div>

    </div>
</template>

<script>
import "swiper/css/swiper.css";
import { getAboutData } from "@/api/about";
export default {
    data() {
        return {
            tabdata: [
                { tebc_id: 1 },
                { tebc_id: 2 },
                { tebc_id: 3 },
                { tebc_id: 4 },
            ],
            swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 30,
                normalizeSlideIndex: false,
                watchSlidesVisibility: true,/*避免出现bug*/
            },

            currentLanguage: localStorage.getItem('currentLanguage'),
            imgurl: "",
			aboutData:"",

        }
    },

    created() {

        setTimeout(() => {
            this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');
        }, 600);

        this.imgurl = require('@/assets/images/integral_' + this.currentLanguage + '.png')
        // this.currentLanguage = localStorage.getItem('currentLanguage')
    },
	mounted() {
	    this.getAboutData();
	},
	 methods: {
		async getAboutData() {
		   const res = await getAboutData();
		   if (res.status == 200) {
			   this.tabdata = res.data.banner_list;
			   this.aboutData = res.data.tsap_content;
		   }
		},
	 }
	
}
</script>

<style lang="scss" scoped>
.d-img {
    max-width: 100%;
}

.card-box {
    margin-top: 26px;

    .card-list {
        min-height: 200px;
        background: #f0f5ff;
        border-radius: 8px 8px 8px 8px;
        margin-left: 24px;
        padding: 30px 12px 30px 24px;
        position: relative;
        top: 0px;
        transition: all 0.1s;
        z-index: 1;

        .p-img {
            width: 60px;
            position: absolute;
            right: 10px;
            top: 22px;
            z-index: -1;
        }

        .td1 {
            font-weight: 700;
            font-size: 18px;
            color: #3d3d3d;
            line-height: 30px;
        }

        .d1 {
            font-size: 16px;
            color: #858d9e;
            line-height: 22px;
            margin-top: 16px;
        }
    }
}

.content-box {
    padding: 30px 80px;

    .list-card {

        background-color: #ffffff;
        padding: 24px;
        border-radius: 6px;
        margin-top: 16px;

        .t1 {
            font-size: 22px;
            line-height: 28px;
            font-weight: bold;
            color: #3d3d3d;
            position: relative;
            padding-left: 19px;

            &::after {
                content: "";
                display: block;
                width: 4px;
                height: 20px;
                background: #B7251E;
                border-radius: 0px 0px 0px 0px;
                position: absolute;
                left: 0;
                top: 5px;
            }
        }

        .desc {

            background-color: #ffffff;
            padding: 24px;
            border-radius: 6px;
        }
    }

    .container-box {
        max-width: 1400px;
        margin: 0 auto;
    }

}

.page-box {
    background: #F8F8F8;
}

.banner {
    width: 100%;
    // height: 420px;

    .swiper-container {
        height: 100%;
    }

    .banner-link {
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
}
</style>